/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, disable, themeV2 } from '@insticator/insticator-ui';
import { hoverTransition, aniSpeed } from '../../../../../utils/styles/general';



/* ++++++++++ --------------- NAV ITEM : STYLES --------------- ++++++++++ */
export default {
	navitem: {
		flex: '0',
		'& .item': {
			background: 'transparent',
			borderRadius: pxToEm(12),
			color: themeV2.color.primary.main,
      fontWeight: themeV2.typography.weight.medium,
			cursor: 'pointer',
			display: 'flex',
			alignItems: 'center',
			userSelect: 'none',
			paddingRight: pxToEm(16),
			position: 'relative',
			zIndex: '2',
			'& .helpericon': {
				flex: `0 0 ${pxToEm(48)}`,
				// width: pxToEm(48),
				height: pxToEm(48),
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				extend: hoverTransition(),
        color: themeV2.color.base.gray.dark
			},
			'& .text': {
				flex: '1',
				fontSize: pxToEm(15),
				extend: hoverTransition()
			},
			'& .indicator': {
				flex: '0',
				extend: hoverTransition(),
        '&.icon': {
          color: themeV2.color.base.gray.dark
        }
			}
		},
		'& .subitems': {
			position: 'relative',
			zIndex: '1',
			width: '100%',
			'& .line': {
				background: themeV2.color.base.gray.light,
				width: pxToEm(1),
				height: '100%',
				position: 'absolute',
				top: pxToEm(-16),
				left: pxToEm(24),
				zIndex: '1'
			},
			'& .links': {
				position: 'relative',
				zIndex: '2'
			},
			'&.isActive': {
				'&-false': {
					// opacity: '0',
					// position: 'absolute',
					// zIndex: '-1',
					display: 'none'
				},
				'&-true': {
			        // animationName: 'fadeInDown',
			        // animationDuration: aniSpeed,
			        // animationFillMode: 'forwards',
			        // zIndex: '1',
			        display: 'block'
				}
			}
		},
		'&.isDisabled': {
			'&-true': {
				extend: disable,
        color: themeV2.color.base.disabled,
        filter: 'none',
        opacity: 1,
        '& .text, & .icon': {
          color: `${themeV2.color.base.disabled} !important`
        }
			}
		},
		'&.isActive': {
			'&-true': {
				'& .item': {
					background: themeV2.color.base.blue.light,
					color: themeV2.color.primary.main,
					cursor: 'default'
				}
			},
			'&-false': {
				'&.subitemsOpen': {
					'&-true': {
						'& .item': {
							// background: 'rgb(245, 248, 251)'
						}
					}
				},
				'&:hover': {
					'& .item': {
						// filter: 'brightness(97%)'
					}
				}
			}
		}
	}
}; 